import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import reduxPromiseMiddleware from 'redux-promise-middleware';
import reduxSaga from 'redux-saga';

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import objectHash from 'object-hash';

import { initialFilterState, IStore, rootReducer } from '@reducers';
import { rootSaga } from '@sagas';

export const reduxPersistKey = objectHash(initialFilterState, {
  excludeValues: false,
  algorithm: 'sha1',
  encoding: 'hex'
});

export default (initialState: IStore) => {
  const sagaMiddleware = reduxSaga();

  const persistConfig = {
    storage,
    key: reduxPersistKey,
    whitelist: ['filter']
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = createStore(
    persistedReducer,
    initialState,
    composeWithDevTools(applyMiddleware(reduxPromiseMiddleware, sagaMiddleware))
  );

  sagaMiddleware.run(rootSaga);

  return store;
};
